webpackJsonp([1],{

/***/ "MZrC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ec78313","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("MZrC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ServiceList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ServiceList = ({
    name: 'ServiceList',
    data: function data() {
        return {
            error: false,
            loading: true,
            lat: null,
            lng: null,
            serviceTypes: [{ "id": "accounting", "label": "Accounting" }, { "id": "airport", "label": "Airport" }, { "id": "amusement_park", "label": "Amusement Park" }, { "id": "aquarium", "label": "Aquarium" }, { "id": "art_gallery", "label": "Art Gallery" }, { "id": "atm", "label": "ATM" }, { "id": "bakery", "label": "Bakery" }, { "id": "bank", "label": "Bank" }, { "id": "bar", "label": "Bar" }, { "id": "beauty_salon", "label": "Beauty Salon" }, { "id": "bicycle_store", "label": "Bicycle Store" }, { "id": "book_store", "label": "Book Store" }, { "id": "bowling_alley", "label": "Bowling Alley" }, { "id": "bus_station", "label": "Bus Station" }, { "id": "cafe", "label": "Cafe" }, { "id": "campground", "label": "Campground" }, { "id": "car_dealer", "label": "Car Dealer" }, { "id": "car_rental", "label": "Car Rental" }, { "id": "car_repair", "label": "Car Repair" }, { "id": "car_wash", "label": "Car Wash" }, { "id": "casino", "label": "Casino" }, { "id": "cemetery", "label": "Cemetery" }, { "id": "church", "label": "Church" }, { "id": "city_hall", "label": "City Hall" }, { "id": "clothing_store", "label": "Clothing store" }, { "id": "convenience_store", "label": "Convenience store" }, { "id": "courthouse", "label": "Courthouse" }, { "id": "dentist", "label": "Dentist" }, { "id": "department_store", "label": "Department Store" }, { "id": "doctor", "label": "Doctor" }, { "id": "electrician", "label": "Electrician" }, { "id": "electronics_store", "label": "Electronics Store" }, { "id": "embassy", "label": "Embassy" }, { "id": "establishment", "label": "Establishment" }, { "id": "finance", "label": "Finance" }, { "id": "fire_station", "label": "Fire Station" }, { "id": "florist", "label": "Florist" }, { "id": "food", "label": "Food" }, { "id": "funeral_home", "label": "Funeral Home" }, { "id": "furniture_store", "label": "Furniture Store" }, { "id": "gas_station", "label": "Gas Station" }, { "id": "general_contractor", "label": "General Contractor" }, { "id": "geocode", "label": "Geocode" }, { "id": "grocery_or_supermarket", "label": "Grocery or Supermarket" }, { "id": "gym", "label": "Gym" }, { "id": "hair_care", "label": "Hair Care" }, { "id": "hardware_store", "label": "Hardware Store" }, { "id": "health", "label": "Health" }, { "id": "hindu_temple", "label": "Hindu Temple" }, { "id": "home_goods_store", "label": "Home Goods Store" }, { "id": "hospital", "label": "Hospital" }, { "id": "insurance_agency", "label": "Insurance Agency" }, { "id": "jewelry_store", "label": "Jewelry Store" }, { "id": "laundry", "label": "Laundry" }, { "id": "lawyer", "label": "Lawyer" }, { "id": "library", "label": "Library" }, { "id": "liquor_store", "label": "Liquor Store" }, { "id": "local_government_office", "label": "Local Government Office" }, { "id": "locksmith", "label": "Locksmith" }, { "id": "lodging", "label": "Lodging" }, { "id": "meal_delivery", "label": "Meal Delivery" }, { "id": "meal_takeaway", "label": "Meal Takeaway" }, { "id": "mosque", "label": "Mosque" }, { "id": "movie_rental", "label": "Movie Rental" }, { "id": "movie_theater", "label": "Movie Theater" }, { "id": "moving_company", "label": "Moving Company" }, { "id": "museum", "label": "Museum" }, { "id": "night_club", "label": "Night Club" }, { "id": "painter", "label": "Painter" }, { "id": "park", "label": "Park" }, { "id": "parking", "label": "Parking" }, { "id": "pet_store", "label": "Pet Store" }, { "id": "pharmacy", "label": "Pharmacy" }, { "id": "physiotherapist", "label": "Physiotherapist" }, { "id": "place_of_worship", "label": "Place of Worship" }, { "id": "plumber", "label": "Plumber" }, { "id": "police", "label": "Police" }, { "id": "post_office", "label": "Post Office" }, { "id": "real_estate_agency", "label": "Real Estate Agency" }, { "id": "restaurant", "label": "Restaurant" }, { "id": "roofing_contractor", "label": "Roofing Contractor" }, { "id": "rv_park", "label": "RV Park" }, { "id": "school", "label": "School" }, { "id": "shoe_store", "label": "Shoe Store" }, { "id": "shopping_mall", "label": "Shopping Mall" }, { "id": "spa", "label": "Spa" }, { "id": "stadium", "label": "Stadium" }, { "id": "storage", "label": "Storage" }, { "id": "store", "label": "Store" }, { "id": "subway_station", "label": "Subway Station" }, { "id": "synagogue", "label": "Synagogue" }, { "id": "taxi_stand", "label": "Taxi Stand" }, { "id": "train_station", "label": "Train Station" }, { "id": "travel_agency", "label": "Travel Agency" }, { "id": "university", "label": "University" }, { "id": "veterinary_care", "label": "Veterinary Care" }, { "id": "zoo", "label": "Zoo" }]
        };
    },

    mounted: function mounted() {
        this.$nextTick(function () {
            if (this.lat === null) {
                console.log('get geolocation', this.lat);
                var that = this;
                navigator.geolocation.getCurrentPosition(function (res) {
                    console.log(res);
                    that.lng = res.coords.longitude;
                    that.lat = res.coords.latitude;
                    that.loading = false;
                }, function (err) {
                    console.error(err);
                    that.loading = false;
                    that.error = true;
                });
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e91540e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServiceList.vue
var ServiceList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Service List")]),_vm._v(" "),(_vm.loading)?_c('div',[_vm._v("\n    Looking up your location...\n    ")]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',[_vm._v("\n    I'm sorry, but I had a problem getitng your location. Check the console for details.\n    ")]):_vm._e(),_vm._v(" "),(!_vm.loading && !_vm.error)?_c('div',[_c('ul',_vm._l((_vm.serviceTypes),function(service){return _c('li',{key:service.id},[_c('router-link',{attrs:{"to":{name:'typeList', params:{type:service.id, name:service.label, lat:_vm.lat, lng:_vm.lng} }}},[_vm._v(_vm._s(service.label))])],1)}))]):_vm._e()])}
var ServiceList_staticRenderFns = []
var ServiceList_esExports = { render: ServiceList_render, staticRenderFns: ServiceList_staticRenderFns }
/* harmony default export */ var components_ServiceList = (ServiceList_esExports);
// CONCATENATED MODULE: ./src/components/ServiceList.vue
var ServiceList_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ServiceList___vue_template_functional__ = false
/* styles */
var ServiceList___vue_styles__ = null
/* scopeId */
var ServiceList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ServiceList___vue_module_identifier__ = null
var ServiceList_Component = ServiceList_normalizeComponent(
  ServiceList,
  components_ServiceList,
  ServiceList___vue_template_functional__,
  ServiceList___vue_styles__,
  ServiceList___vue_scopeId__,
  ServiceList___vue_module_identifier__
)

/* harmony default export */ var src_components_ServiceList = (ServiceList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TypeList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var SEARCH_API = 'https://openwhisk.ng.bluemix.net/api/v1/web/rcamden%40us.ibm.com_My%20Space/googleplaces/search.json';

// used for search max distance
var RADIUS = 2000;

/* harmony default export */ var TypeList = ({
	name: 'ServiceList',
	data: function data() {
		return {
			results: [],
			loading: true
		};
	},

	created: function created() {
		var _this = this;

		fetch(SEARCH_API + '?lat=' + this.lat + '&lng=' + this.lng + '&type=' + this.type + '&radius=' + RADIUS).then(function (res) {
			return res.json();
		}).then(function (res) {
			console.log('res', res);
			_this.results = res.result;
			_this.loading = false;
		});
	},
	props: ['name', 'type', 'lat', 'lng']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c273d98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TypeList.vue
var TypeList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),(_vm.loading)?_c('div',[_vm._v("\n    Looking up data...\n    ")]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',[_c('ul',_vm._l((_vm.results),function(result){return _c('li',{key:result.id},[_c('router-link',{attrs:{"to":{name:'detail', params:{placeid:result.place_id} }}},[_vm._v(_vm._s(result.name))])],1)})),_vm._v(" "),(_vm.results.length === 0)?_c('p',[_vm._v("\n        Sorry, no results.\n        ")]):_vm._e(),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back")])],1)]):_vm._e()])}
var TypeList_staticRenderFns = []
var TypeList_esExports = { render: TypeList_render, staticRenderFns: TypeList_staticRenderFns }
/* harmony default export */ var components_TypeList = (TypeList_esExports);
// CONCATENATED MODULE: ./src/components/TypeList.vue
var TypeList_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var TypeList___vue_template_functional__ = false
/* styles */
var TypeList___vue_styles__ = null
/* scopeId */
var TypeList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TypeList___vue_module_identifier__ = null
var TypeList_Component = TypeList_normalizeComponent(
  TypeList,
  components_TypeList,
  TypeList___vue_template_functional__,
  TypeList___vue_styles__,
  TypeList___vue_scopeId__,
  TypeList___vue_module_identifier__
)

/* harmony default export */ var src_components_TypeList = (TypeList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Detail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var DETAIL_API = 'https://openwhisk.ng.bluemix.net/api/v1/web/rcamden%40us.ibm.com_My%20Space/googleplaces/detail.json';

/* harmony default export */ var Detail = ({
	name: 'Detail',
	data: function data() {
		return {
			detail: [],
			loading: true
		};
	},

	methods: {
		goBack: function goBack() {
			this.$router.go(-1);
		}
	},
	created: function created() {
		var _this = this;

		fetch(DETAIL_API + '?placeid=' + this.placeid).then(function (res) {
			return res.json();
		}).then(function (res) {
			console.log('res', res.result);
			/*
   modify res.result to include a nice label for price
   */
			res.result.price = '';
			if (res.price_level) {
				if (res.result.price_level === 0) res.result.price = "Free";
				if (res.result.price_level === 1) res.result.price = "Inexpensive";
				if (res.result.price_level === 2) res.result.price = "Moderate";
				if (res.result.price_level === 3) res.result.price = "Expensive";
				if (res.result.price_level === 4) res.result.price = "Very expensive";
			}
			_this.detail = res.result;

			// add a google maps url
			_this.detail.mapUrl = 'https://maps.googleapis.com/maps/api/staticmap?center=' + _this.detail.geometry.location.lat + ',' + _this.detail.geometry.location.lng + '&zoom=14&markers=color:blue%7C' + _this.detail.geometry.location.lat + ',' + _this.detail.geometry.location.lng + '&size=310x310&sensor=true&key=AIzaSyBw5Mjzbn8oCwKEnwI2gtClM17VMCaNBUY';
			_this.loading = false;
		});
	},
	props: ['placeid']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62f8cce4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Detail.vue
var Detail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',[_vm._v("\n    Looking up data...\n    ")]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',[_c('div',[_c('img',{attrs:{"src":_vm.detail.icon}}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.detail.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.detail.formatted_address))])]),_vm._v(" "),_c('div',[_c('p',[_vm._v("\n                This business is currently \n                "),(_vm.detail.opening_hours)?_c('span',[(_vm.detail.opening_hours.open_now)?_c('span',[_vm._v("open.")]):_c('span',[_vm._v("closed.")])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v("\n                Phone: "+_vm._s(_vm.detail.formatted_phone_number)),_c('br'),_vm._v("\n                Website: "),_c('a',{attrs:{"href":_vm.detail.website,"target":"_new"}},[_vm._v(_vm._s(_vm.detail.website))]),_c('br'),_vm._v(" "),(_vm.detail.price)?_c('span',[_vm._v("Items here are generally priced \""+_vm._s(_vm.detail.price)+"\".")]):_vm._e()]),_vm._v(" "),_c('p',[_c('img',{staticClass:"full-image",attrs:{"src":_vm.detail.mapUrl,"width":"310","height":"310"}})])]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.goBack($event)}}},[_vm._v("Go Back")])])]):_vm._e()])}
var Detail_staticRenderFns = []
var Detail_esExports = { render: Detail_render, staticRenderFns: Detail_staticRenderFns }
/* harmony default export */ var components_Detail = (Detail_esExports);
// CONCATENATED MODULE: ./src/components/Detail.vue
var Detail_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Detail___vue_template_functional__ = false
/* styles */
var Detail___vue_styles__ = null
/* scopeId */
var Detail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Detail___vue_module_identifier__ = null
var Detail_Component = Detail_normalizeComponent(
  Detail,
  components_Detail,
  Detail___vue_template_functional__,
  Detail___vue_styles__,
  Detail___vue_scopeId__,
  Detail___vue_module_identifier__
)

/* harmony default export */ var src_components_Detail = (Detail_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js






vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    name: 'ServiceList',
    component: src_components_ServiceList
  }, {
    path: '/type/:type/name/:name/lat/:lat/lng/:lng',
    component: src_components_TypeList,
    name: 'typeList',
    props: true
  }, {
    path: '/detail/:placeid',
    component: src_components_Detail,
    name: 'detail',
    props: true
  }]
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5a4e3b0c7063e09298a2.js